module.exports = __webpack_public_path__ + "static/interestrate-93432ae6a16965eb4f325a35b7cf756e.jpg";